<template>
    <div>

        <reservation-confirm-modal
        :is-visible="showModal"
        @close="handleModalClose"
        @onClickBtnForceReserveSelectedCustomer="onClickBtnForceReserveSelectedCustomer"
        @onClickBtnWaitReserveSelectedCustomer="onClickBtnWaitReserveSelectedCustomer"
      />
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">일일스케줄</span>
            <span class="txt">센터의 일일 스케줄 일정을 관리하고 확인할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="right">
                    <select-form
                        :select-data="selectFormCenter.data"
                        :select-value="selectFormCenter.value"
                        :selected-value="selectedCenterId"
                        @update:set="onUpdateSelectedCenter"
                    />
                    <select-form
                        :select-data="selectFormTeam.data"
                        :select-value="selectFormTeam.value"
                        :selected-value="selectFormTeam.selectedValue"
                        @update:set="onUpdateSelectedTeam"
                    />
                    <div v-click-outside="outsideClick" :class="{ on: selectOpen }" class="ui-select">
                        <button
                            @click="selectOpen = !selectOpen"
                            :style="
                                this.allowedMenuEvent.eventCds != null &&
                                !this.allowedMenuEvent.eventCds.includes('SC_EVENT_006')
                                    ? 'background: #f1f5f7;'
                                    : ''
                            "
                            :disabled="
                                this.allowedMenuEvent.eventCds != null &&
                                !this.allowedMenuEvent.eventCds.includes('SC_EVENT_006')
                            "
                        >
                            <span class="txt">강사선택</span>
                        </button>
                        <ul style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                            <li>
                                <div class="com-check">
                                    <input
                                        id="select-check-all"
                                        v-model="isCheckAllTeachers"
                                        name="select-check-all"
                                        type="checkbox"
                                        @change="onChangeCheckAllTeachers"
                                    />
                                    <label for="select-check-all">전체선택</label>
                                </div>
                            </li>
                            <li
                                v-for="(teacher, index) in centerTeachers
                                    .filter((t) => t.scheduleShowYn !== false)
                                    .sort((a, b) => a.name.localeCompare(b.name))"
                                :key="index"
                            >
                                <div class="com-check">
                                    <input
                                        :id="`select-check-${teacher.centerStaffId}`"
                                        v-model="teacher.checked"
                                        :name="`select-check-${teacher.centerStaffId}`"
                                        type="checkbox"
                                        @change="onChangeCheckTeacher($event)"
                                    />
                                    <label :for="`select-check-${teacher.centerStaffId}`">{{ teacher.name }}</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <button class="com-search-reset"></button>
                </div>
            </div>
            <div class="line">
                <schedule-date-selector
                    :callback-update-date="onUpdateScheduleDateSelector"
                    :interval="1"
                    :selected-date="selectedDate"
                ></schedule-date-selector>
                <div class="right">
                    <button class="top-link-btn on">일일스케줄</button>
                    <button class="top-link-btn" @click="goTo('/madmin/schedule/group')">그룹 주간표</button>
                    <button class="top-link-btn" @click="goTo('/madmin/schedule/teacher')">강사 주간표</button>
                    <button class="top-link-btn" @click="goTo('/madmin/schedule/room')">룸 스케줄표</button>
                    <button class="top-link-btn green" @click="onClickBtnNewReservation">신규예약</button>
                    <button class="com-setting-btn" @click="onClickBtnOpenScheduleTimeSetter">
                        <span class="blind">설정</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="com-tab">
            <button :class="selectedLessonType === '' ? 'on' : ''" @click="onClickBtnLessonType('')">전체</button>
            <button :class="selectedLessonType === 'P' ? 'on' : ''" @click="onClickBtnLessonType('P')">개인</button>
            <button :class="selectedLessonType === 'O' ? 'on' : ''" @click="onClickBtnLessonType('O')">OT</button>
            <button :class="selectedLessonType === 'D' ? 'on' : ''" @click="onClickBtnLessonType('D')">듀엣</button>
            <button :class="selectedLessonType === 'G' ? 'on' : ''" @click="onClickBtnLessonType('G')">그룹</button>
        </div>

        <div class="schedule-table-content">
            <table class="schedule-table">
                <colgroup>
                    <col style="width: 100px" />
                    <col
                        v-for="n in checkedTeachers.filter((t) => t.scheduleShowYn !== false).length"
                        :key="n"
                        style="width: 190px"
                    />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button class="prev-btn"><span class="blind">이전 강사</span></button>
                            <button class="next-btn"><span class="blind">다음 강사</span></button>
                        </th>
                        <th v-for="(teacher, index) in checkedTeachers.filter((t) => t.scheduleShowYn !== false)" :key="index">
                            {{ teacher.name }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(hour, index) in searchTimeHours" :key="index"
                    :class="{ currenttime: hour === currentHour }">
                        <th>{{ `${hour}:00` }}</th>
                        <td
                            v-for="(teacher, idx) in checkedTeachers.filter((t) => t.scheduleShowYn !== false)"
                            :key="idx"
                            :title="teacher.name + ' / ' + selectedDate + ' / ' + `${hour}:00`"
                            @click="onClickEmptyTimeTable($event, teacher, hour)"
                        >
                            <div
                                v-if="
                                    teacher.scheduleShowYn !== false &&
                                    !isEmpty(scheduleTable[teacher.centerStaffId]) &&
                                    !isEmpty(scheduleTable[teacher.centerStaffId][hour])
                                "
                                :class="`grid-area num-${scheduleTable[teacher.centerStaffId][hour].cols}`"
                            >
                                <!--
              m0 ~ m50 : 0분부터 50분까지 (단위 5)
              h60 ~ m180 : 50분부터 180분까지 (단위 5)
              -->
                                <template v-for="(d, idx) in scheduleTable[teacher.centerStaffId][hour].lessonList">
                                    <div
                                        v-if="d.scheduleType === 'M'"
                                        :key="idx"
                                        :class="scheduleClass(d)"
                                        :style="meetingStyle(d)"
                                        class="item-box meeting"
                                        @mouseleave="onMouseleaveSchedule(d)"
                                        @mouseover="onMouseoverSchedule(d)"
                                        @click.stop="onClickBtnShowMeeting(d)"
                                    >
                                        <div class="top-line">
                                            <span class="name">{{ d.titleName }}</span>
                                            <span class="time">
                                                {{ getHmFromTime(d.lessonStartTime) }} ~
                                                {{ getHmFromTime(d.lessonEndTime) }}
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        v-else-if="
                                            d.lessonsType === 'P' || d.lessonsType === 'D' || d.lessonsType === 'O'
                                        "
                                        :key="idx"
                                        :class="scheduleClass(d)"
                                        :style="scheduleStyle(d)"
                                        class="item-box"
                                        @mouseleave="onMouseleaveSchedule(d)"
                                        @mouseover="onMouseoverSchedule(d)"
                                        @click.stop="onClickDailyScheduleItem(d)"
                                    >
                                        <div class="top-line">
                                            <span class="name">{{ d.students[0].centerCustomerName }}</span>
                                            <span class="type">({{ d.lessonsType }})</span>

                                            <span
                                                v-if="
                                                    scheduleClass(d).includes('m30') || scheduleClass(d).includes('h30')
                                                "
                                                style="font-size: 12px; line-height: 20px; color: #9f9f9f"
                                            >
                                                {{ lessonFirstStudent(d).contractSeq }}/{{
                                                    lessonFirstStudent(d).lessonCount
                                                }}
                                            </span>
                                            <span v-else class="time">
                                                {{ lessonFirstStudent(d).contractSeq }}/{{
                                                    lessonFirstStudent(d).lessonCount
                                                }}
                                            </span>
                                        </div>
                                        <div :style="test(scheduleClass(d))">
                                            <span class="info-txt">
                                                <template v-for="(room, index) in d.rooms">
                                                    {{ index > 0 ? ' / ' : '' }}{{ room.centerRoom.name }}
                                                </template>
                                            </span>
                                            <!--                                      <template v-if="!((scheduleClass(d).includes('m30')||scheduleClass(d).includes('h30'))&&(scheduleClass(d).includes('m30')&&scheduleClass(d).includes('h30')))">-->
                                            <!--                                        <span v-if='d.lessonMemo !== null && d.lessonMemo !== ""' class='info-btn purple' style='bottom: 36px'>-->
                                            <!--                                          메모-->
                                            <!--                                      </span>-->
                                            <template
                                                v-if="
                                                    !(
                                                        (scheduleClass(d).includes('m30') ||
                                                            scheduleClass(d).includes('h30')) &&
                                                        scheduleClass(d).includes('m30') &&
                                                        scheduleClass(d).includes('h30')
                                                    )
                                                "
                                            >
                                                <template
                                                    v-if="
                                                        scheduleClass(d).includes('m30') &&
                                                        scheduleClass(d).includes('h30')
                                                    "
                                                >
                                                    <span
                                                        v-if="d.lessonMemo !== null && d.lessonMemo !== ''"
                                                        class="info-btn purple"
                                                        style="right: 48px"
                                                    >
                                                        메모
                                                    </span>
                                                </template>
                                                <template v-else>
                                                    <span
                                                        v-if="d.lessonMemo !== null && d.lessonMemo !== ''"
                                                        class="info-btn purple"
                                                        style="right: 48px; bottom: 8px"
                                                    >
                                                        메모
                                                    </span>
                                                </template>
                                            </template>
                                            <!--                                      <template v-if="!((scheduleClass(d).includes('m30')||scheduleClass(d).includes('h30'))&&(scheduleClass(d).includes('m30')&&scheduleClass(d).includes('h30')))">-->
                                            <!--                                        <span v-if='d.lessonMemo !== null && d.lessonMemo !== ""' class='info-btn purple' style='bottom: 36px'>-->
                                            <!--                                          메모-->
                                            <!--                                      </span>-->
                                            <!--                                      </template>-->

                                            <div
                                                v-if="scheduleTable[teacher.centerStaffId][hour].cols < 3"
                                                style="display: flex"
                                            >
                                                <template
                                                    v-if="
                                                        (scheduleClass(d).includes('m30') ||
                                                            scheduleClass(d).includes('h30')) &&
                                                        scheduleClass(d).includes('m30') &&
                                                        scheduleClass(d).includes('h30')
                                                    "
                                                >
                                                    <span
                                                        v-if="d.lessonMemo !== null && d.lessonMemo !== ''"
                                                        class="info-btn purple"
                                                        style="right: 48px"
                                                    >
                                                        메모
                                                    </span>
                                                </template>
                                                <span
                                                    v-if="lessonFirstStudent(d).attendanceStatus === 'X'"
                                                    class="info-btn red"
                                                >
                                                    결석
                                                </span>
                                                <span
                                                    v-else-if="lessonFirstStudent(d).attendanceStatus === '-'"
                                                    class="info-btn blue"
                                                >
                                                    예약
                                                </span>
                                                <span
                                                    v-else-if="d.students[0].attendanceStatus === 'O'"
                                                    class="info-btn blue"
                                                >
                                                    출석
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-else-if="d.lessonsType === 'G'"
                                        :key="idx"
                                        :class="scheduleClass(d)"
                                        :style="scheduleStyle(d)"
                                        class="item-box tooltip-box"
                                        @mouseleave="onMouseleaveSchedule(d)"
                                        @mouseover="onMouseoverSchedule(d)"
                                        @click.stop="onClickScheduleItem(d)"
                                    >
                                        <div v-if="d.students.length !== 0" class="balloon">
                                            <div class="info-user">
                                                <ul class="list">
                                                    <li
                                                        v-for="(m, idx) in d.students"
                                                        :key="idx"
                                                        style="display: flex; align-items: center; font-size: 14px"
                                                    >
                                                        <img
                                                            width="17px"
                                                            height="17px"
                                                            v-if="m.attendanceStatus === 'O'"
                                                            src="../../../../public/img/icons/ic_case3.png"
                                                        />
                                                        <img
                                                            width="17px"
                                                            height="17px"
                                                            v-else-if="m.attendanceStatus === 'X'"
                                                            src="../../../../public/img/icons/ic_case2.png"
                                                        />
                                                        <img
                                                            width="17px"
                                                            height="17px"
                                                            v-else
                                                            src="../../../../public/img/icons/ic_case1.png"
                                                        />
                                                        <span>{{ m.centerCustomerName }}</span>
                                                        <span
                                                            :style="
                                                                m.tickettype === 'G'
                                                                    ? 'color:rgba(51, 126, 169, 1)'
                                                                    : 'color : rgb(217, 115, 13)'
                                                            "
                                                        >
                                                            ({{ m.tickettype }})
                                                        </span>
                                                        {{ m.contractSeq }}/{{
                                                            m.less_cnt_type_cd === 'U'
                                                                ? 'F'
                                                                : m.less_cnt_type_cd === 'W'
                                                                ? m.resvlimitcnt + 'n'
                                                                : m.lessonCount
                                                        }}
                                                        <img
                                                            v-if="m.memo"
                                                            width="17px"
                                                            height="17px"
                                                            src="../../../../public/img/icons/ic_memo.png"
                                                        />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="top-line">
                                            <span class="name">{{ d.titleName }}</span>
                                            <span class="num">
                                                {{ d.students ? d.students.length : 0 }}/{{ d.lessonMemberMaxCount }}명
                                                {{
                                                    d.lessonMemberWaitCount !== 0 ? `(${d.lessonMemberWaitCount})` : ''
                                                }}
                                            </span>
                                            <span class="time">
                                                {{ getHmFromTime(d.lessonStartTime) }} ~
                                                {{ getHmFromTime(d.lessonEndTime) }}
                                            </span>
                                            <br />
                                            <span v-if="d.lessonOffYn" class="lessonOff">휴강</span>
                                        </div>
                                        <span class="info-txt">{{ d.lessonName }}</span>
                                    </div>
                                </template>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- 예시 시간설정 레이어
      <div class="time-schedule">
          <div class="grid-area">
              <div class="item-box" style="border-color:#86dbd4;" @click="infoPop = true">
                  <div class="top-line">
                      <span class="name">홍길자 aa</span>
                      <span class="type">(P)</span>
                      <span class="time">08:20 ~ 09:20</span>
                  </div>
                  <span class="info-txt">리포머룸 / 리포머룸</span>
                  <span class="info-btn red">결석</span>
                  <span class="info-btn blue">예약</span>
              </div>
          </div>
      </div>
      //예시 시간설정 레이어 -->
        </div>

        <!-- 정보확인 팝업 -->
        <div v-show="infoPop" class="layer-pop square-type">
            <div class="view-content w480">
                <button class="close" @click="onClickBtnCloseReservationInfoDlg">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y info">
                    <span class="sub-title">정보확인</span>
                    <div class="info-btn-area">
                        <button
                            v-if="!isSelectedReservationUnableCancel"
                            @click="checkAllowedClickAttendAction(onClickBtnShowAttendanceAppoval)"
                        >
                            출결승인하기
                        </button>
                        <button @click="onClickBtnShowReservation">예약확인</button>
                        <button
                            v-if="!isSelectedReservationUnableCancel"
                            @click="checkAllowedClickEditAction(onClickBtnCancelSelectedReservation)"
                        >
                            예약취소
                        </button>
                        <button @click="onClickBtnShowReservationCustomerInfo">회원정보보기</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 스케줄표 시간설정 팝업 -->
        <schedule-time-setter-dlg
            :callback-cancel="onCancelScheduleTimeSetterDlg"
            :callback-confirm="onConfirmScheduleTimeSetterDlg"
            :end-hour="searchTime.endHour"
            :end-min="searchTime.endMin"
            :is-show="timePop"
            :start-hour="searchTime.startHour"
            :start-min="searchTime.startMin"
        ></schedule-time-setter-dlg>

        <!-- 스케줄 예약 팝업 -->
        <div v-show="reservationPop" class="layer-pop square-type">
            <div class="view-content w950">
                <button class="close" @click="onClickBtnCancelReservation"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <div class="com-tab">
                        <button
                            v-if="isShowLessonReservationTab"
                            :class="{ on: layerTab === 1 }"
                            @click="openLessonReservationDlg"
                        >
                            스케줄 예약{{ reservationDlg.isModifyLessonReservation ? ' 수정' : '' }}
                        </button>
                        <button
                            v-if="isShowTeacherScheduleTab"
                            :class="{ on: layerTab === 2 }"
                            @click="openTeacherScheduleDlg"
                        >
                            일정등록{{ reservationDlg.isModifyTeacherSchedule ? ' 수정' : '' }}
                        </button>
                    </div>
                    <!-- 스케줄예약, 스케줄수정 -->
                    <lesson-reservation-dlg
                        ref="lessonReservationDlg"
                        :callback-cancel="onCancelLessonReservationDlg"
                        :callback-success="onSuccessLessonReservationDlg"
                        :init-center-id="selectedCenterId"
                        :select-form-teacher="selectFormTeacher"
                    ></lesson-reservation-dlg>
                    <!-- //스케줄예약, 스케줄수정 -->
                    <!-- 일정등록, 일정수정 -->
                    <teacher-schedule-dlg
                        ref="teacherScheduleDlg"
                        :callback-cancel="onCancelTeacherScheduleDlg"
                        :callback-success="onSuccessTeacherScheduleDlg"
                        :init-center-id="selectedCenterId"
                        :select-form-teacher="selectFormTeacher"
                    ></teacher-schedule-dlg>
                    <!-- //일정등록, 일정수정 -->
                </div>
            </div>
        </div>

        <!-- 출결승인/출결완료 팝업 -->
        <attendance-approval-dlg
            ref="attendanceApprovalDlg"
            :callback-success="onSuccessAttendApproval"
        ></attendance-approval-dlg>

        <!-- 정보확인 팝업 -->
        <div v-if="groupInfoPop" class="layer-pop square-type">
            <div class="view-content w480">
                <button class="close" @click="groupInfoPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y info">
                    <span class="sub-title">정보확인</span>
                    <div class="info-btn-area">
                        <button @click="onClickBtnShowCustomerReservation">예약/내역보기</button>
                        <button @click="onClickBtnShowGroupLessonModify">그룹정보수정</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 예약내역, 그룹정보 팝업 -->
        <div v-if="reservationPopForGroup" class="layer-pop square-type">
            <div class="view-content w880">
                <button class="close" @click="onClickBtnCloseGroupReservation">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">스케쥴 상세</span>
                    <div class="com-tab">
                        <button :class="{ on: layerTab === 1 }" @click="onClickTabGroupLessonDlgLayer1">
                            예약 내역
                        </button>
                        <button :class="{ on: layerTab === 2 }" @click="onClickTabGroupLessonDlgLayer2">
                            수업 정보
                        </button>
                    </div>
                    <!-- 예약내역 -->
                    <div v-if="layerTab === 1" class="view-area">
                        <div class="top-group-info">
                            <div class="line">
                                <span class="cnt">
                                    {{
                                        nowStatus(
                                            editFieldReservCustomer.data.members,
                                            editFieldReservCustomer.data.lessonMemberMaxCount
                                        )
                                    }}
                                </span>
                                <span v-show="editFieldReservCustomer.data.rooms">
                                    수업 장소: {{ roomName(editFieldReservCustomer.data.rooms) }}
                                </span>
                                <span class="time">
                                    {{ getReplacedLessonDate(editFieldReservCustomer.data.lessonDate) }}
                                    {{ getHmFromTime(editFieldReservCustomer.data.lessonStartTime) }} ~
                                    {{ getHmFromTime(editFieldReservCustomer.data.lessonEndTime) }}
                                </span>
                            </div>
                            <div class="line">
                                <span class="info-txt">{{ editFieldReservCustomer.data.lessonName }}</span>
                                <span v-if="editFieldReservCustomer.data.lessonOffYn" class="lessonOff">휴강</span>
                            </div>
                        </div>
                        <table class="com-table left">
                            <colgroup>
                                <col style="width: 140px" />
                                <col style="width: 570px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>회원명</th>
                                    <td>
                                        <input
                                            :value="editFieldReservCustomer.selectedCustomer.name"
                                            placeholder="회원명, 연락처(‘-’ 제외)"
                                            readonly
                                            type="text"
                                            @click="
                                                onClickBtnOpenSearchCustomer(editFieldReservCustomer.data.lessonOffYn)
                                            "
                                        />
                                        <button
                                            v-if="!editFieldReservCustomer.data.lessonOffYn"
                                            class="com-btn"
                                            readonly
                                            @click="
                                                onClickBtnOpenSearchCustomer(editFieldReservCustomer.data.lessonOffYn)
                                            "
                                        >
                                            검색
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <th>이용권명</th>
                                    <td>
                                        <select-form
                                            :disabled="isEmpty(editFieldReservCustomer.selectedCustomer.id)"
                                            :select-data="editFieldReservCustomer.selectFormCustomerProduct.data"
                                            :select-value="editFieldReservCustomer.selectFormCustomerProduct.value"
                                            :selected-value="
                                                editFieldReservCustomer.selectFormCustomerProduct.selectedValue
                                            "
                                            class="w440"
                                            @update:set="onUpdateSetCustomerProduct"
                                        ></select-form>
                                        <div>
                                            <span v-if="isUsedLessonCount" style="font-size: 12px; color: red">
                                                예약 횟수를 모두 소진하였습니다.
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="bottom-btn">
                            <button
                                v-if="!isUsedLessonCount && !editFieldReservCustomer.data.lessonOffYn"
                                class="com-btn blue"
                                @click="checkAllowedClickEditAction(onClickBtnReserveSelectedCustomer)"
                            >
                                예약하기
                            </button>
                        </div>
                        <table class="com-table">
                            <colgroup>
                                <col style="width: 40px" />
                                <col style="width: 120px" />
                                <col style="width: 150px" />
                                <col style="width: 160px" />
                                <col style="width: 150px" />
                                <col style="width: 80px" />
                                <col style="width: 80px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>
                                        <div class="com-check">
                                            <input
                                                id="check-all"
                                                v-model="selectedAll"
                                                type="checkbox"
                                                @change="checkAll"
                                            />
                                            <label for="check-all"></label>
                                        </div>
                                    </th>
                                    <th>회원명</th>
                                    <th>휴대폰번호</th>
                                    <th>예약일시</th>
                                    <th>횟수</th>
                                    <th>출결</th>
                                    <th>관리</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="editFieldReservCustomer.data.members.length === 0">
                                    <td colspan="100">예약내역이 없습니다.</td>
                                </tr>
                                <template v-for="(m, index) in editFieldReservCustomer.data.members">
                                    <tr :id="index" style="position: relative" :key="index">
                                        <td>
                                            <div class="com-check">
                                                <input
                                                    type="checkbox"
                                                    :id="`lesson-member-${index}`"
                                                    v-model="selectedMembers"
                                                    :value="m.centerCustomerId"
                                                />
                                                <label :for="`lesson-member-${index}`"></label>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="check-link">
                                                <router-link
                                                    :to="{
                                                        path: `/madmin/member/info/${centerId}`,
                                                        query: { customerId: m.centerCustomerId },
                                                    }"
                                                    class="link"
                                                >
                                                    {{ m.centerCustomerName }}
                                                </router-link>
                                            </div>
                                        </td>
                                        <td>{{ m.phone | customerPhoneFilter }}</td>
                                        <td>{{ m.reservedDate | utcToYMDHmFilter }}</td>
                                        <td
                                            v-if="m.status === '-' && m.reservationStatus === 'RW'"
                                            style="color: #4780fd"
                                        >
                                            대기
                                        </td>
                                        <td v-else>
                                            {{ m.tickettype }} {{ m.contractSeq }}/{{
                                                m.less_cnt_type_cd === 'U'
                                                    ? 'F'
                                                    : m.less_cnt_type_cd === 'W'
                                                    ? m.resvlimitcnt + 'n'
                                                    : m.lessonCount
                                            }}
                                        </td>
                                        <td v-if="m.status === '-'">
                                            <button
                                                class="com-btn red"
                                                @click="
                                                    checkAllowedClickEditAction(
                                                        onClickBtnCancelReservationCustomer,
                                                        m,
                                                        index
                                                    )
                                                "
                                            >
                                                취소
                                            </button>
                                        </td>
                                        <td v-else>
                                            <span v-if="m.status === 'O'" style="color: #00c7e5">
                                                {{ getAttendanceStatusName(m.status) }}
                                            </span>
                                            <span style="color: #f64444" v-else-if="m.status === 'X'">
                                                {{ getAttendanceStatusName(m.status) }}
                                            </span>
                                            <span v-else>
                                                {{ getAttendanceStatusName(m.status) }}
                                            </span>
                                        </td>
                                        <td>
                                            <button
                                                @click="testForGroup($event, index, m.centerCustomerId, m.memo)"
                                                class="com-btn"
                                            >
                                                메모
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="m.memo">
                                        <td colspan="6">
                                            <input type="text" style="width: 575px" v-model="m.memo" />
                                            <button
                                                @click="updateMemo(m.centerCustomerId, m.memo)"
                                                style="height: 24px; line-height: 17px; margin-top: 5px"
                                                class="com-btn blue"
                                            >
                                                수정
                                            </button>
                                            <button
                                                @click="removeMemo(m.centerCustomerId), (m.memo = '')"
                                                class="com-btn red"
                                            >
                                                삭제
                                            </button>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                        <template v-if="editFieldReservCustomer.data.members.length > 0">
                            <!--                        <div class="btn-line">-->
                            <!--                            <button class="com-btn" @click="checkAllowedClickEditAction(onClickBtnCancelReservationCustomer)">예약취소</button>-->
                            <!--                        </div>-->
                            <div class="reason-line">
                                <input
                                    v-model="editFieldReservCustomer.reason"
                                    class="w400"
                                    placeholder="결석일 경우, 사유를 입력해주세요."
                                    type="text"
                                />
                                <div class="right-btn">
                                    <button
                                        class="com-btn blue"
                                        @keydown.enter.prevent
                                        @click="checkAllowedClickAttendAction(onClickBtnAttendCustomers)"
                                    >
                                        출석처리
                                    </button>
                                    <button
                                        class="com-btn"
                                        @keydown.enter.prevent
                                        @click="checkAllowedClickAttendAction(onClickBtnAbsentCustomers)"
                                    >
                                        결석처리
                                    </button>
                                    <button
                                        class="com-btn outline"
                                        @keydown.enter.prevent
                                        @click="checkAllowedClickAttendAction(onSendMsg)"
                                    >
                                        문자발송
                                    </button>
                                </div>
                            </div>
                        </template>
                    </div>
                    <!-- //예약내역 -->
                    <!-- 그룹정보 -->
                    <div v-if="layerTab === 2" class="view-area">
                        <div class="top-group-info">
                            <div class="line">
                                <span class="cnt">
                                    {{ editFieldGroupLesson.data.lessonMemberReservationCount }}/{{
                                        editFieldGroupLesson.data.lessonMemberMaxCount
                                    }}명
                                </span>
                                <span v-show="editFieldReservCustomer.data.rooms">
                                    수업 장소: {{ roomName(editFieldReservCustomer.data.rooms) }}
                                </span>
                                <span class="time">
                                    {{ getReplacedLessonDate(editFieldGroupLesson.data.lessonDate) }}
                                    {{ getHmFromTime(editFieldGroupLesson.data.lessonStartTime) }} ~
                                    {{ getHmFromTime(editFieldGroupLesson.data.lessonEndTime) }}
                                </span>
                            </div>
                            <div class="line">
                                <span class="info-txt">{{ editFieldGroupLesson.lessonName }}</span>
                                <span v-if="editFieldReservCustomer.data.lessonOffYn" class="lessonOff">휴강</span>
                            </div>
                        </div>
                        <table class="com-table left">
                            <colgroup>
                                <col style="width: 140px" />
                                <col style="width: 570px" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>강사명</th>
                                    <td>
                                        <select-form
                                            :select-data="[...selectFormTeacher.data]"
                                            :select-value="[...selectFormTeacher.value]"
                                            :selected-value="editFieldGroupLesson.selectedTeacher"
                                            class="w120"
                                            @update:set="(v) => (editFieldGroupLesson.selectedTeacher = v)"
                                        ></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>수업기간일자</th>
                                    <td>
                                        <div class="com-calendar-wrap">
                                            <single-calendar
                                                :disabled="editFieldGroupLesson.isModify"
                                                :start-date="editFieldGroupLesson.lessonStartDate"
                                            ></single-calendar>
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :disabled="editFieldGroupLesson.isModify"
                                                :end-date="editFieldGroupLesson.lessonEndDate"
                                            ></single-calendar>
                                        </div>
                                        <!--                                        <p class="notice-txt">종료기간이 미확정인 경우 1~2년 뒤로 설정해 놓으셔도 좋습니다.</p>-->
                                    </td>
                                </tr>
                                <tr>
                                    <th>수업요일</th>
                                    <td>
                                        <div class="detail-check-line">
                                            <div v-for="(wd, index) in weekdayIndex" :key="index" class="com-check">
                                                <input
                                                    :id="`check-wd-${index}`"
                                                    v-model="editFieldGroupLesson.checkedDay[index]"
                                                    :disabled="editFieldGroupLesson.isModify"
                                                    false-value="X"
                                                    name="check-r1"
                                                    true-value="O"
                                                    type="checkbox"
                                                />
                                                <label :for="`check-wd-${index}`">{{ wd }}</label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>수업시작시간</th>
                                    <td>
                                        <select-form
                                            :disabled="editFieldGroupLesson.isModify"
                                            :select-data="editFieldGroupLesson.selectFormStartTime.hourList"
                                            :select-value="editFieldGroupLesson.selectFormStartTime.hourList"
                                            :selected-value="editFieldGroupLesson.startHour"
                                            class="w100"
                                        ></select-form>
                                        <span class="dot">:</span>
                                        <select-form
                                            :disabled="editFieldGroupLesson.isModify"
                                            :select-data="editFieldGroupLesson.selectFormStartTime.minList"
                                            :select-value="editFieldGroupLesson.selectFormStartTime.minList"
                                            :selected-value="editFieldGroupLesson.startMin"
                                            class="w100"
                                        ></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>수업진행시간</th>
                                    <td>
                                        <select-form
                                            :disabled="editFieldGroupLesson.isModify"
                                            :select-data="[...editFieldGroupLesson.selectFormLessonTime.data]"
                                            :select-value="[...editFieldGroupLesson.selectFormLessonTime.value]"
                                            :selected-value="editFieldGroupLesson.selectFormLessonTime.selectedValue"
                                            class="w100"
                                        ></select-form>
                                    </td>
                                </tr>
                                <tr>
                                    <th>룸 선택</th>
                                    <td>
                                        <select-form
                                            class="w120"
                                            :select-data="['선택안함', ...rooms.data]"
                                            :select-value="[null, ...rooms.value]"
                                            :selected-value="rooms.selectedValue"
                                            @update:set="selectRoom"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>프로그램명</th>
                                    <td>
                                        <input v-model="editFieldGroupLesson.lessonName" class="w320" type="text" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>최대예약인원</th>
                                    <td>
                                        <input
                                            v-model="editFieldGroupLesson.lessonMemberMaxCount"
                                            class="w60 center"
                                            type="text"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>대기가능인원</th>
                                    <td>
                                        <input
                                            v-model="editFieldGroupLesson.lessonMemberWaitEnableCount"
                                            :disabled="editFieldGroupLesson.isModify"
                                            class="w60 center"
                                            type="text"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>강제휴강인원</th>
                                    <td>
                                        <input
                                            v-model="editFieldGroupLesson.lessonForceOffMemberCount"
                                            :disabled="editFieldGroupLesson.isModify"
                                            class="w60 center"
                                            type="text"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="notice-txt">변경된 정보는 당일에만 적용됩니다.</p>
                        <div class="bottom-btn">
                            <button
                                v-if="!editFieldReservCustomer.data.lessonOffYn"
                                class="com-btn"
                                @click="checkAllowedClick('SC', 5, onClickBtnModifyGroupLesson)"
                            >
                                수정하기
                            </button>
                            <button
                                v-if="!editFieldReservCustomer.data.lessonOffYn"
                                class="com-btn imp-red"
                                @click="checkAllowedClick('SC', 5, onClickBtnOffGroupLessonConfirm)"
                            >
                                {{ editFieldGroupLesson.lessonOffYn === false ? '휴강하기' : '휴강취소' }}
                            </button>
                        </div>
                    </div>
                    <!-- //그룹정보 -->
                </div>
            </div>
        </div>
        <!-- 회원 검색 결과 팝업 -->
        <search-customer-dlg
            :callback-cancel="onCancelSearchCustomerDlg"
            :callback-select="onSelectSearchCustomerDlg"
            :center-id="selectedCenterId"
            :is-show="memberPop"
        ></search-customer-dlg>
        <!-- 출결승인 팝업 -->
        <attend-or-absent-success-dlg
            :callback-ok="closeAttendOrAbsentDlg"
            :datetime="attendAbsentSuccessDlg.datetime"
            :is-attend="attendAbsentSuccessDlg.isAttend"
            :is-show="attendAbsentSuccessDlg.isShow"
            :member-names="attendAbsentSuccessDlg.names"
        ></attend-or-absent-success-dlg>

        <!-- 휴강하기 확인 팝업 -->
        <div v-if="restPop" class="layer-pop square-type">
            <div class="view-content w650">
                <button class="close" @click="restPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">
                        {{ editFieldGroupLesson.lessonOffYn === false ? '휴강하기' : '휴강취소' }}
                    </span>
                    <div class="top-group-info type-black">
                        <div class="line">
                            <span class="cnt">
                                {{ editFieldGroupLesson.data.teacher.name }}
                                {{ editFieldGroupLesson.data.lessonMemberReservationCount }}/{{
                                    editFieldGroupLesson.data.lessonMemberMaxCount
                                }}
                                (명)
                            </span>
                            <span class="time">
                                {{ getReplacedLessonDate(editFieldGroupLesson.data.lessonDate) }}
                                {{ getHmFromTime(editFieldGroupLesson.data.lessonStartTime) }} ~
                                {{ getHmFromTime(editFieldGroupLesson.data.lessonEndTime) }}
                            </span>
                        </div>
                        <div class="line">
                            <span class="info-txt">{{ editFieldGroupLesson.lessonName }}</span>
                        </div>
                    </div>
                    <div class="cancel-info-txt">
                        <p>
                            <span class="red">
                                {{
                                    editFieldGroupLesson.lessonOffYn === false
                                        ? '회원님들에게 휴강에 대한 안내를 하셨습니까?'
                                        : ''
                                }}
                            </span>
                        </p>
                        <p>
                            {{
                                editFieldGroupLesson.lessonOffYn === false
                                    ? '해당 시간에 예약된 스케줄은 모두'
                                    : '해당 시간의 휴강이'
                            }}
                            <span class="red">취소</span>
                            됩니다.
                        </p>
                    </div>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="restPop = false">휴강취소</button>
                        <button class="com-btn blue" @click="onClickBtnOffGroupLesson">확인</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 휴강하기 완료 팝업 -->
        <div v-if="restCompletePop" class="layer-pop square-type">
            <div class="view-content w650">
                <button class="close" @click="onClickBtnGroupLessonCancelComplete">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">휴강하기</span>
                    <div class="top-group-info type-black">
                        <div class="line">
                            <span class="cnt">
                                {{ editFieldGroupLesson.data.teacher.name }}
                                {{ editFieldGroupLesson.data.lessonMemberReservationCount }}/{{
                                    editFieldGroupLesson.data.lessonMemberMaxCount
                                }}
                                (명)
                            </span>
                            <span class="time">
                                {{ getReplacedLessonDate(editFieldGroupLesson.data.lessonDate) }}
                                {{ getHmFromTime(editFieldGroupLesson.data.lessonStartTime) }} ~
                                {{ getHmFromTime(editFieldGroupLesson.data.lessonEndTime) }}
                            </span>
                        </div>
                        <div class="line">
                            <span class="info-txt">{{ editFieldGroupLesson.lessonName }}</span>
                        </div>
                    </div>
                    <div class="cancel-info-txt">
                        <p>
                            휴강 및 예약이
                            <span class="red">취소</span>
                            되었습니다.
                        </p>
                    </div>
                    <div class="bottom-btn">
                        <!--                        <button class="com-btn" @click="restCompletePop = false">취소</button>-->
                        <button class="com-btn blue" @click="onClickBtnGroupLessonCancelComplete">확인</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';
import ScheduleDateSelector from '@/components/ScheduleDateSelector';
import ScheduleTimeSetterDlg from '@/components/ScheduleTimeSetterDlg';
import LessonReservationDlg from '@/components/LessonReservationDlg';
import TeacherScheduleDlg from '@/components/TeacherScheduleDlg';
import AttendanceApprovalDlg from '@/components/AttendanceApprovalDlg';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import SearchCustomerDlg from '@/components/SearchCustomerDlg';
import AttendOrAbsentSuccessDlg from '@/components/AttendOrAbsentSuccessDlg';
import { pagingInfo } from '@/assets/js/common';
import ReservationConfirmModal from '../../../components/ReservationConfirmModal.vue'

export default {
    name: 'ScheduleDay',
    mixins: [MixinAllowedMenu],

    components: {
        LessonReservationDlg,
        ScheduleDateSelector,
        ScheduleTimeSetterDlg,
        TeacherScheduleDlg,
        AttendanceApprovalDlg,
        SearchCustomerDlg,
        AttendOrAbsentSuccessDlg,
        ReservationConfirmModal,
    },
    props: {},
    watch: {
        // async selectedDate() {
        //     if (this.isInitFinished) {
        //         this.selectedDate = moment(this.selectedDate).format('YYYY-MM-DD');
        //         const tempTeachers = this.checkedTeachers
        //         this.checkedTeachers = [];
        //         await this.fetchCenterTearchers();
        //         for (let i = 0; i < this.centerTeachers.length; i++) {
        //             for (let j = 0; j < tempTeachers.length; j++) {
        //                 if(this.centerTeachers[i].centerStaffId === tempTeachers[j].centerStaffId){
        //                     this.centerTeachers[i].checked = true;
        //                     this.checkedTeachers.push(this.centerTeachers[i])
        //                 }
        //             }
        //         }
        //         await this.fetchDailySchedule();
        //     }
        // },
    },
    computed: {
        isShowLessonReservationTab() {
            // return (this.reservationDlg.teacher.centerStaffId == this.staffId || this.isAllowed('SC', 1)) && !this.reservationDlg.isModifyTeacherSchedule;
            return !this.reservationDlg.isModifyTeacherSchedule;
        },
        isShowTeacherScheduleTab() {
            // return (this.reservationDlg.teacher.centerStaffId == this.staffId || this.isAllowed('SC', 2)) && !this.reservationDlg.isModifyLessonReservation;
            return !this.reservationDlg.isModifyLessonReservation;
        },
        currentHour() {
            return String(new Date().getHours()).padStart(2, '0');
        },
        /*
isModifyLessonReservation(){
return this.reservationDlg.isModifyLessonReservation;
}, */
        searchTimeHours() {
            const res = [];
            const start = parseInt(this.searchTime.startHour);
            const end = parseInt(this.searchTime.endHour);

            for (let i = start; i <= end; i++) {
                res.push(i.toString().padStart(2, '0'));
            }

            return res;
        },
        topZIndex() {
            return 999;
        },
        isSelectedReservationUnableCancel() {
            if (Utils.isEmpty(this.selectedReservation)) {
                return false;
            }

            const status = this.lessonFirstStudent(this.selectedReservation).attendanceStatus;
            return status === 'O' || status === 'X';
        },
    },
    data() {
        return {
            rooms: { data: [], value: [], selectedValue: null },
            centerRooms: [],
            selectedReservation: null,
            isInitFinished: false,
            centerId: '',
            staffId: '',
            selectedLessonType: '',
            centerTeachers: [],
            checkedTeachers: [],
            isCheckAllTeachers: true,
            scheduleTable: {},
            scheduleList: [],
            // 메인 화면
            selectedDate: moment().format('YYYY-MM-DD'),
            selectedCenterId: '',
            selectedTeam: '',
            selectFormCenter: {
                data: ['센터선택'],
                value: [''],
            },
            selectFormTeam: {
                data: ['팀선택'],
                value: [''],
                selectedValue: '',
            },
            selectFormTeacher: {
                data: ['선택'],
                value: [''],
                selectedValue: '',
            },
            searchTime: {
                startHour: '06',
                startMin: '00',
                endHour: '23',
                endMin: '00',
            },
            reservationDlg: {
                isModifyLessonReservation: false,
                isModifyTeacherSchedule: false,
            },
            reservationSetting: {},
            // 팝업 노출
            selectOpen: false,
            timePop: false, // 스케줄표 시간설정 팝업
            reservationPop: false, // 스케줄 예약 팝업
            layerTab: 1, // 스케줄 예약 팝업 탭 활성화
            infoPop: false, // 정보확인 팝업
            memberPop: false, // 회원 검색 팝업
            attendInfoPop: false, // 출결 팝업
            attendPop: false, // 출결완료 팝업
            pagingInfo: { ...pagingInfo },

            groupInfoPop: false, // 정보확인 팝업 (group)
            editFieldReservCustomer: {
                data: {
                    members: [],
                },
                selectedCustomer: {
                    id: '',
                    name: '',
                },
                selectFormCustomerProduct: {
                    list: [],
                    data: [],
                    value: [],
                    selectedValue: '',
                },
                selectedProduct: null,
                customerList: [],
                reason: '',
                isAttend: true,
                checkedNames: [],
            },
            editFieldGroupLesson: {
                data: {},
                selectedTeacher: '',
                lessonStartDate: '',
                lessonEndDate: '',
                checkedDay: ['X', 'X', 'X', 'X', 'X', 'X', 'X'],
                lessonStartTime: '',
                lessonEndTime: '',
                lessonTotalTime: 60,
                lessonName: '',
                lessonMemberMaxCount: 0,
                lessonMemberWaitEnableCount: 0,
                lessonForceOffMemberCount: 0,
                startHour: '',
                startMin: '',
                selectFormStartTime: {
                    hourList: [],
                    minList: [],
                },
                selectFormLessonTime: {
                    data: ['30분', '1시간', '1시간 30분', '2시간', '2시간 30분', '3시간'],
                    value: [30, 60, 90, 120, 150, 180],
                    selectedValue: 60,
                },
                isModify: true,
            },
            isUsedLessonCount: false, // 이용권 예약 횟수 소진 여부
            reservationPopForGroup: false,
            attendAbsentSuccessDlg: {
                isShow: false,
                isAttend: true,
                names: [],
                datetime: '',
            },
            weekdayIndex: ['월', '화', '수', '목', '금', '토', '일'],
            weekdays: [],
            restPop: false, // 휴강하기 확인 팝업
            restCompletePop: false, // 휴강하기 완료 팝업

            selectedAll: false,
            selectedMembers: [],
            showModal: false  // 모달의 표시 여부를 제어하는 상태
        };
    },
    mounted() {
        this.init();
    },
    methods: {

          // 모달 열기
          openModal() {
            this.showModal = true
        },
        // 모달 닫기
        handleModalClose() {
            this.showModal = false
        },

        getCenterRoomReservation(centerRoomId) {
            const {
                centerId,
                selectFormStartHour,
                selectFormStartMin,
                selectFormLessonTime,
                scheduleRepeatWeek,
                editFieldGroupLesson,
            } = this;
            const lessonStartDate = moment(editFieldGroupLesson.data.lessonDate).format('YYYYMMDD');
            const lessonEndDate = moment(editFieldGroupLesson.data.lessonDate).format('YYYYMMDD');
            const tmFormat = 'HH:mm:ss';
            const dtFormat = 'YYYY-MM-DD HH:mm:ss';
            const startTime = `${editFieldGroupLesson.startHour}:${editFieldGroupLesson.startMin}:00`;
            const lessonStartDatetime = `${editFieldGroupLesson.data.lessonDate} ${startTime}`;
            const endTime = moment(lessonStartDatetime, dtFormat)
                .add(editFieldGroupLesson.lessonTotalTime, 'minutes')
                .format(tmFormat);
            // 스웨거 검색: 룸 예약 현황 조회
            return api.get(`/admin/api/centerRoom/reservation/status/group`, {
                params: {
                    centerId,
                    lessonStartTime: startTime,
                    lessonEndTime: endTime,
                    centerRoomId,
                    lessonStartDate,
                    lessonEndDate,
                    scheduleRepeatWeek: editFieldGroupLesson.scheduleRepeatWeek,
                    centerLessonScheduleId: editFieldGroupLesson.data.centerLessonScheduleId,
                },
            });
        },
        async selectRoom(centerRoomId) {
            try {
                const { data } = await this.getCenterRoomReservation(centerRoomId);
                if (data === 1) {
                    this.rooms.selectedValue = centerRoomId;
                } else {
                    if (data) {
                        alert(data);
                    } else {
                        this.rooms.selectedValue = centerRoomId;
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        getCenterRooms() {
            return api.get(`/admin/api/centerRoom/${this.centerId}`);
        },
        async fetchCenterRooms() {
            try {
                const { data } = await this.getCenterRooms();
                this.rooms.data = data.map((element) => {
                    if (element.useYn) {
                        return element.name;
                    }
                });
                // this.rooms.data.unshift("선택안함")
                this.rooms.value = data.map((element) => {
                    if (element.useYn) {
                        return element.centerRoomId;
                    }
                });
                // this.rooms.value.unshift("")
                this.rooms.selectedValue = null;
            } catch (e) {
                console.log(e);
            }
        },
        roomName(rooms) {
            if (!rooms || !rooms.length) return '';

            return rooms[0].centerRoomName;
        },
        doAfterCalendarChanged() {
            // 캘린더가 변경되었을때,
            this.fetchDailySchedule();
        },

        async onUpdateScheduleDateSelector(date) {
            this.selectedDate = moment(date).format('YYYY-MM-DD');
            const tempTeachers = this.centerTeachers;

            await this.fetchCenterTearchers();
            if (this.isCheckAllTeachers) {
                this.checkAllTeachers(true);
            } else {
                for (let i = 0; i < this.centerTeachers.length; i++) {
                    for (let j = 0; j < tempTeachers.length; j++) {
                        if (
                            tempTeachers[j].checked &&
                            this.centerTeachers[i].centerStaffId === tempTeachers[j].centerStaffId
                        ) {
                            this.centerTeachers[i].checked = true;
                        }
                    }
                }
            }

            this.doAfterCalendarChanged();

            await this.refreshCheckedTeachers();
        },

        putGroupLessonCancel(scheduleId, scheduleMasterId) {
            //  스웨거 : 그룹레슨 휴강
            return api.put(
                `/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLessonCancel/${scheduleMasterId}/${scheduleId}`
            );
        },

        async onClickBtnGroupLessonCancelComplete() {
            this.reservationPop = false;
            this.restPop = false;
            this.restCompletePop = false;

            this.closeGroupReservation();
        },

        async onClickBtnOffGroupLesson() {
            try {
                const { centerLessonScheduleId, centerLessonScheduleMasterId } = this.editFieldGroupLesson.data;
                if (Utils.isEmpty(centerLessonScheduleId) || Utils.isEmpty(centerLessonScheduleMasterId)) {
                    alert('오류가 발생하였습니다.');
                    return false;
                }

                const { data } = await this.putGroupLessonCancel(centerLessonScheduleId, centerLessonScheduleMasterId);

                // this.reservationPop = false;
                this.restPop = false;
                this.restCompletePop = true;
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        async onClickBtnOffGroupLessonConfirm() {
            this.restPop = true;
        },
        deleteCheckGroupLesson(startDate, endDate, masterId, billStat) {
            return api.get(`/admin/api/center/${this.centerId}/lesson/calculate/search`, {
                params: {
                    ...this.pagingInfo,
                    startDate: moment(startDate).format('YYYYMMDD'),
                    endDate: moment(endDate).format('YYYYMMDD'),
                    centerLessonScheduleMasterID: masterId,
                    billStatus: billStat,
                },
            });
        },
        // 전체 선택
        checkAll() {
            if (this.selectedAll) {
                this.selectedMembers = this.editFieldReservCustomer.data.members.map(
                    (member) => member.centerCustomerId
                );
            }
        },
        async onClickBtnModifyGroupLesson() {
            const { editFieldGroupLesson } = this;
            const check = await this.deleteCheckGroupLesson(
                this.selectedReservation.lessonDate,
                this.selectedReservation.lessonDate,
                this.selectedReservation.centerLessonScheduleMasterId
            );
            for (let i = 0; i < check.data.items.length; i++) {
                if (
                    check.data.items[i].clsc_atnd_status_cd === '-' &&
                    check.data.items[i].clsc_resv_status_cd !== 'RW'
                ) {
                } else {
                    alert('정산완료 된 수업이 있습니다. 정산을 취소 후 강사 변경을 해주세요.');
                    return false;
                }
            }
            if (editFieldGroupLesson.lessonMemberMaxCount < editFieldGroupLesson.data.lessonMemberReservationCount) {
                const limitCount = editFieldGroupLesson.data.lessonMemberReservationCount;
                const msg = `현재 예약인원이 ${limitCount}명입니다. ${limitCount}명 이하로는 수정할 수 없습니다.`;
                alert(msg);
                return false;
            }

            if (!confirm('수업정보를 수정하시겠습니까?\n변경된 정보는 당일에만 적용됩니다.')) {
                return false;
            }

            try {
                const { centerLessonScheduleId, centerLessonScheduleMasterId } = this.editFieldGroupLesson.data;
                const { selectedTeacher, lessonName, lessonMemberMaxCount } = this.editFieldGroupLesson;
                const params = {
                    centerLessonScheduleId,
                    lessonStaffId: selectedTeacher,
                    lessonName,
                    lessonMemberMaxCount,
                    eventType: 'SC',
                    eventContent: '그룹레슨 단건수정',
                    centerRoomId: this.rooms.selectedValue,
                };
                const { data } = await this.putGroupLessonOneModify(centerLessonScheduleMasterId, params);
                // ㅁㅁㅁㅁㅁㅁㅁㅁㅁㅁㅁ
                this.closeGroupReservation();
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
            }
        },
        putGroupLessonOneModify(centerLessonScheduleMasterId, params) {
            return api.put(
                `/admin/api/center/${this.selectedCenterId}/lesson/${centerLessonScheduleMasterId}/group/one/modify`,
                { ...params }
            );
        },
        getCenterScheduleGroupLessonDetail(scheduleId, scheduleMasterId) {
            // 스웨거: 그룹강의 상세조회
            return api.get(
                `/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLessonDetail/${scheduleMasterId}/${scheduleId}`
            );
        },
        putGroupLessonAbsentCustomers(centerLessonScheduleId, centerCustomerIds, lessonCustomerOffReason) {
            // 스웨거: 그룹레슨 결석처리
            const attendanceDevice = 'AW';
            const params = {
                centerId: this.selectedCenterId,
                centerLessonScheduleId,
                attendanceDevice,
                centerCustomerIds,
                lessonCustomerOffReason,
            };

            return api.put(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLessonAbsent/customers`, {
                ...params,
            });
        },

        closeAttendOrAbsentDlg() {
            this.attendAbsentSuccessDlg.isShow = false;
            this.fetchGroupLessonReserve();
        },
        isWeekdaysContainDate(date) {
            const finded = this.weekdays.find((arg) => arg.value === date);
            return !Utils.isEmpty(finded);
        },
        getAWeek(date) {
            if (!this.isWeekdaysContainDate(date)) {
                // 포함되지 않으면 해당 날짜가 속한 일주일의 날짜를 가져옴
                this.weekdays = Utils.getAWeekdays(date, 1, 'M/DD');
            }
        },
        getAttendanceStatusName(status) {
            return Utils.getAttendanceStatusName(status);
        },
        putGroupLessonAttendCustomers(centerLessonScheduleId, centerCustomerIds) {
            // 스웨거: 그룹레슨 출석처리
            const attendanceDevice = 'AW';
            const params = {
                centerId: this.selectedCenterId,
                centerLessonScheduleId,
                attendanceDevice,
                centerCustomerIds,
            };

            return api.put(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLessonAttend/customers`, {
                ...params,
            });
        },

        validateAttendAbsent(centerCustomerIds, isAbsent = false) {
            // validate
            if (centerCustomerIds.length === 0) {
                alert('회원을 선택해주세요.');
                return false;
            }
            if (isAbsent && Utils.isEmpty(this.editFieldReservCustomer.reason.trim())) {
                alert('결석이유를 입력해주세요');
                return false;
            }
            return true;
        },

        getCheckedGroupLessonCustomerIdsAndNames() {
            const ids = [];
            const names = [];

            this.editFieldReservCustomer.data.members.forEach((member) => {
                if (this.selectedMembers.includes(member.centerCustomerId) && this.isEditableMember(member)) {
                    ids.push(member.centerCustomerId);
                    names.push(member.centerCustomerName);
                }
            });

            return {
                ids,
                names,
            };
        },
        // 출석처리
        async onClickBtnAttendCustomers() {
            const { ids, names } = this.getCheckedGroupLessonCustomerIdsAndNames();

            if (!this.validateAttendAbsent(ids)) {
                return;
            }

            if (!confirm('선택된 회원들을 출석처리 하시겠습니까?')) {
                return;
            }

            try {
                const { attendAbsentSuccessDlg } = this;
                const { data } = this.editFieldReservCustomer;

                await this.putGroupLessonAttendCustomers(data.centerLessonScheduleId, ids);
                console.log('data.lessonDate', data.lessonDate);
                console.log('data.lessonStartTime', data.lessonStartTime);
                attendAbsentSuccessDlg.datetime = `${data.lessonDate} ${this.getHmFromTime(data.lessonStartTime)}`;
                attendAbsentSuccessDlg.isAttend = true;
                attendAbsentSuccessDlg.names = names;
                attendAbsentSuccessDlg.isShow = true;
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        // 결석처리
        async onClickBtnAbsentCustomers() {
            const { ids, names } = this.getCheckedGroupLessonCustomerIdsAndNames();

            if (!this.validateAttendAbsent(ids)) {
                return false;
            }

            if (!confirm('선택된 회원들을 결석처리 하시겠습니까?')) {
                return false;
            }

            try {
                const { attendAbsentSuccessDlg } = this;
                const { data } = this.editFieldReservCustomer;

                await this.putGroupLessonAbsentCustomers(
                    data.centerLessonScheduleId,
                    ids,
                    this.editFieldReservCustomer.reason
                );

                attendAbsentSuccessDlg.datetime = `${data.lessonDate} ${this.getHmFromTime(data.lessonStartTime)}`;
                attendAbsentSuccessDlg.isAttend = false;
                attendAbsentSuccessDlg.names = names;
                attendAbsentSuccessDlg.isShow = true;
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },

        // 문자발송
        onSendMsg() {
            const data = [];
            this.selectedMembers.forEach((customerId) => {
                const customer = this.editFieldReservCustomer.data.members.find(
                    (member) => member.centerCustomerId === customerId
                );
                if (customer) {
                    data.push({
                        centerCustomerId: customer.centerCustomerId,
                        name: customer.centerCustomerName,
                        phone: customer.phone,
                    });
                }
            });
            this.$router.push({
                name: 'messageSend',
                params: { data },
            });
        },

        async updateMemo(centerCustomerId, memo) {
            const { centerLessonScheduleId, centerLessonScheduleMasterId } = this.selectedReservation;

            await api.put(
                `/admin/api/center/${this.centerId}/lesson/schedule/groupLesson/${centerLessonScheduleId}/${centerCustomerId}`,
                {
                    memo,
                }
            );
            await this.fetchGroupLessonReserve();
        },
        async removeMemo(centerCustomerId) {
            const { centerLessonScheduleId, centerLessonScheduleMasterId } = this.selectedReservation;

            await api.put(
                `/admin/api/center/${this.centerId}/lesson/schedule/groupLesson/${centerLessonScheduleId}/${centerCustomerId}`,
                {
                    memo: '',
                }
            );

            await this.fetchGroupLessonReserve();
        },
        getGroupLessonSchedule(centerId) {
            const targetDate = this.selectedDate.replace(/-/g, '');
            const staffIdList = this.getCheckedCenterTeacherIds().join(',');
            const params = {
                targetDate,
                staffIdList,
            };

            if (Utils.isEmpty(staffIdList)) {
                return { data: [] };
            }

            return api.get(`/admin/api/center/${centerId}/lesson/schedule/groupLesson/all`, { params });
        },
        testForGroup(e, index, centerCustomerId, memo) {
            const { centerLessonScheduleId, centerLessonScheduleMasterId } = this.selectedReservation;
            // console.log(e,index, centerCustomerId);
            // return;

            const valid = document.getElementById(`${index}-1`);
            if (valid) {
                return;
            }

            const element = document.getElementById(index);
            const test = document.createElement('tr');
            test.id = `${index}-1`;
            test.style.width = '100%';
            test.style.height = '50px';
            test.style.border = '1px solid #dbdbdb';
            test.style.position = 'relative';
            const input = document.createElement('input');
            input.id = `input${index}`;
            input.style.position = 'absolute';
            input.style.width = '600px';
            input.style.left = '15px';
            input.style.top = '8px';
            input.placeholder = '메모를 입력하세요';
            input.value = memo;
            input.type = 'text';
            test.append(input);
            const button = document.createElement('button');
            button.style.position = 'absolute';
            button.style.left = '617px';
            button.style.top = '12px';
            button.style.height = '24px';
            button.style.lineHeight = '24px';
            button.className = 'com-btn blue';
            if (memo) {
                button.innerText = '수정';
            } else {
                button.innerText = '저장';
            }

            button.onclick = () => {
                document.getElementById(`input${index}`);
                const memo = document.getElementById(`input${index}`).value;
                memo
                    ? api.put(
                          `/admin/api/center/${this.centerId}/lesson/schedule/groupLesson/${centerLessonScheduleId}/${centerCustomerId}`,
                          {
                              memo,
                          }
                      )
                    : alert('메모를 입력해주세요.');
                if (memo) {
                    test.remove();
                }
                this.fetchGroupLessonReserve();
            };
            test.append(button);
            const cancelButton = document.createElement('button');
            cancelButton.style.position = 'absolute';
            cancelButton.style.left = '657px';
            cancelButton.style.top = '12px';
            cancelButton.style.height = '24px';
            cancelButton.style.lineHeight = '24px';
            cancelButton.className = 'com-btn red';
            if (memo) {
                cancelButton.innerText = '삭제';
            } else {
                cancelButton.innerText = '취소';
            }
            cancelButton.onclick = () => {
                if (memo) {
                    api.put(
                        `/admin/api/center/${this.centerId}/lesson/schedule/groupLesson/${centerLessonScheduleId}/${centerCustomerId}`,
                        { memo: '' }
                    );
                    test.remove();
                } else {
                    test.remove();
                }
                this.fetchGroupLessonReserve();
            };
            test.append(cancelButton);
            element.after(test);
            // <input style='position: absolute; width:630px; left:15px; top:8px;' placeholder='메모를 입력하세요' type='text' />
            // <button style='position: absolute; left:647px; top:8px;' className='com-btn blue'>저장</button>
        },

        async onClickBtnCancelReservationCustomer(item, index) {
            if (!confirm(item.reservationStatus === 'RW' ? '대기취소 하시겠습니까?' : '삭제하시겠습니까?')) {
                return false;
            }
            const { centerCustomerId } = item;
            const { centerLessonScheduleMasterId, centerLessonScheduleId } = this.selectedReservation;

            const params = {
                scheduleMasterId: centerLessonScheduleMasterId,
                scheduleId: centerLessonScheduleId,
                customerId: centerCustomerId,
                attendanceDevice: 'AW',
                scheduleCancelReason: '',
                couponYn: false, // 쿠폰 이용권 여부
            };

            // 메모창 지우기..
            try {
                document.getElementById(`${index}-1`).remove();
            } catch (e) {}
            try {
                const { data } = await this.deleteLessonSchedule(params);
                await this.fetchGroupLessonReserve();
                alert('삭제가 완료되었습니다.');
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
            }
        },

        async fetchGroupLessonSchedule() {
            if (Utils.isEmpty(this.selectedCenterId)) {
                return;
            }

            try {
                this.getAWeek(this.selectedDate);
                const { data } = await this.getGroupLessonSchedule(this.selectedCenterId);
                this.scheduleTable = {};
                let zIndex = 200;
                for (const d of data) {
                    if (d.teacher.scheduleShowYn !== false) {
                        const dtKey = d.lessonDate;
                        const tmKey = d.lessonStartTime.split(':')[0];

                        if (Utils.isEmpty(this.scheduleTable[dtKey])) {
                            this.scheduleTable[dtKey] = {};
                        }
                        if (Utils.isEmpty(this.scheduleTable[dtKey][tmKey])) {
                            this.scheduleTable[dtKey][tmKey] = {
                                count: 0,
                                lessonList: [],
                            };
                        }

                        d.titleName = '';
                        d.titleName = d.teacher.name;

                        d.startMin = parseInt(d.lessonStartTime.split(':')[1]);
                        if (d.lessonTotalTime === 0 || Utils.isEmpty(d.lessonTotalTime)) {
                            const lessSt = moment(`${d.lessonDate} ${d.lessonStartTime}`, 'YYYY-MM-DD HH:mm:ss+00');
                            const lessEd = moment(`${d.lessonDate} ${d.lessonEndTime}`, 'YYYY-MM-DD HH:mm:ss+00');
                            const diff = (lessEd.unix() - lessSt.unix()) / 60;
                            d.lessonTotalTime = diff;
                        }

                        d.zIndex = zIndex;
                        // if(d.addedClasses === "meeting") {
                        //   console.log("meeting")
                        // }
                        this.scheduleTable[dtKey][tmKey].lessonList.push(d);
                        this.scheduleTable[dtKey][tmKey].count++;

                        // 2021.01.12 notbadlife@evb
                        // vue 인스턴스에서 감지하게 하기 위해 객체 유지.
                        // 해당 부분이 없으면 zIndex 변화를 실시간 적용하지 못한다.
                        // scheduleList는 반드시 인스턴스의 데이터에 선언할 것
                        this.scheduleList.push(d);

                        zIndex++;
                    }
                }
                for (const [dtKey, hourObject] of Object.entries(this.scheduleTable)) {
                    for (const [hour, schedule] of Object.entries(hourObject)) {
                        schedule.cols = schedule.count;
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },

        putGroupLessonReserveCustomer(params) {
            // 스웨거 검색: 그룹레슨 예약하기
            return api.put(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLessonReserve/customers`, {
                ...params,
            });
        },

        async onClickBtnReserveSelectedCustomer() {
            const { selectedCustomer, selectedProduct, data } = this.editFieldReservCustomer;

            if (Utils.isEmpty(selectedCustomer.id) || Utils.isEmpty(selectedProduct)) {
                !alert('회원과 이용권을 선택해주세요');
                return false;
            }

            if (!confirm('예약하시겠습니까?')) {
                return false;
            }

            try {
                const { name: centerCustomerName } = selectedCustomer;
                const { cc_center_contract_id, cp_center_prod_id, cc_center_cust_id } = selectedProduct;
                const params = {
                    centerId: this.selectedCenterId,
                    centerLessonScheduleId: data.centerLessonScheduleId,
                    centerCustomerId: cc_center_cust_id,
                    centerCustomerName,
                    centerContractId: cc_center_contract_id,
                    centerProductId: cp_center_prod_id,
                    attendanceDevice: 'AW',
                    reservationType: 'S',
                    reservationId: this.staffId,
                };

                const { data: result } = await this.putGroupLessonReserveCustomer(params);
                await this.fetchGroupLessonReserve();
                await this.fetchGroupLessonSchedule();

                const { editFieldReservCustomer } = this;

                editFieldReservCustomer.selectedCustomer.id = '';
                editFieldReservCustomer.selectedCustomer.name = '';
                editFieldReservCustomer.selectFormCustomerProduct = {
                    list: [],
                    data: [],
                    value: [],
                    selectedValue: '',
                };
            } catch (e) {
                console.log(e);
                if('CAPACITY_FULL' === e.response.data.message) {
                    this.openModal();
                }else {
                    Utils.alertResponseErrorMessge(e);
                }
            }
        },
        async onClickBtnWaitReserveSelectedCustomer() {

            const { selectedCustomer, selectedProduct, data } = this.editFieldReservCustomer;

            if (Utils.isEmpty(selectedCustomer.id) || Utils.isEmpty(selectedProduct)) {
                !alert('회원과 이용권을 선택해주세요');
                return false;
            }

            try {
                const { name: centerCustomerName } = selectedCustomer;
                const { cc_center_contract_id, cp_center_prod_id, cc_center_cust_id } = selectedProduct;

                const params = {
                    centerId: this.selectedCenterId,
                    centerLessonScheduleId: data.centerLessonScheduleId,
                    centerCustomerId: cc_center_cust_id,
                    centerCustomerName,
                    centerContractId: cc_center_contract_id,
                    centerProductId: cp_center_prod_id,
                    attendanceDevice: 'AW',
                    reservationType: 'S',
                    reservationId: this.staffId,
                    forceReservationTypeCd : 'FW'
                };


                const { data: result } = await this.putGroupLessonReserveCustomer(params);
                await this.fetchGroupLessonReserve();
                await this.fetchGroupLessonSchedule();

                const { editFieldReservCustomer } = this;

                editFieldReservCustomer.selectedCustomer.id = '';
                editFieldReservCustomer.selectedCustomer.name = '';
                editFieldReservCustomer.selectFormCustomerProduct = {
                    list: [],
                    data: [],
                    value: [],
                    selectedValue: '',
                };
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        async onClickBtnForceReserveSelectedCustomer() {
            const { selectedCustomer, selectedProduct, data } = this.editFieldReservCustomer;

            if (Utils.isEmpty(selectedCustomer.id) || Utils.isEmpty(selectedProduct)) {
                !alert('회원과 이용권을 선택해주세요');
                return false;
            }

            try {
                const { name: centerCustomerName } = selectedCustomer;
                const { cc_center_contract_id, cp_center_prod_id, cc_center_cust_id } = selectedProduct;

                const params = {
                    centerId: this.selectedCenterId,
                    centerLessonScheduleId: data.centerLessonScheduleId,
                    centerCustomerId: cc_center_cust_id,
                    centerCustomerName,
                    centerContractId: cc_center_contract_id,
                    centerProductId: cp_center_prod_id,
                    attendanceDevice: 'AW',
                    reservationType: 'S',
                    reservationId: this.staffId,
                    forceReservationTypeCd : 'FR'
                };

                const { data: result } = await this.putGroupLessonReserveCustomer(params);
                await this.fetchGroupLessonReserve();
                await this.fetchGroupLessonSchedule();

                const { editFieldReservCustomer } = this;

                editFieldReservCustomer.selectedCustomer.id = '';
                editFieldReservCustomer.selectedCustomer.name = '';
                editFieldReservCustomer.selectFormCustomerProduct = {
                    list: [],
                    data: [],
                    value: [],
                    selectedValue: '',
                };
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        getCustomerProductTicket(customerId = '') {
            return api.get(`/admin/api/center/${this.centerId}/lesson`, {
                params: {
                    productType: 'T',
                    centerCustomerId: customerId,
                    page: 1,
                    limit: 999,
                    totalItems: '',
                    itemCount: '',
                    totalPages: '',
                    route: '',
                },
            });
        },

        async fetchCustomerProductTicket() {
            if (Utils.isEmpty(this.editFieldReservCustomer.selectedCustomer.id)) {
                return false;
            }
            try {
                let { data } = await this.getCustomerProductTicket(this.editFieldReservCustomer.selectedCustomer.id);

                data = data.items.filter((value) => value.cc_diff_day >= 0);
                data = data.filter((value) => value.cp_ticket_type_cd === 'G' || value.cp_ticket_type_cd === 'C');
                this.editFieldReservCustomer.selectFormCustomerProduct.data = ['이용권 선택'];
                this.editFieldReservCustomer.selectFormCustomerProduct.value = [''];
                this.editFieldReservCustomer.selectFormCustomerProduct.list = [...data];

                // [듀엣] 플라잉요가 (2/8) 2019-11-09 ~ 2020-12-08
                const len = data.length;
                for (let i = 0; i < len; i++) {
                    const d = data[i];
                    // if (Utils.isEmpty(d.centerProduct)) {
                    //     // 데이터 정합성 오류 : 상품 정보 없음
                    //     continue;
                    // }
                    //
                    // else
                    if (d.resv_total_cnt === d.cc_less_cnt && d.resv_total_cnt && d.cc_less_cnt) {
                        // 횟수가 모두 차감된 경우, 두개가 0,0이 아닐ㄹ경우..
                        continue;
                    }
                    const typeName = Utils.getTicketTypeName(d.cp_ticket_type_cd);
                    const lessonJoinCount = Utils.isEmpty(d.resv_total_cnt) ? 0 : d.resv_total_cnt;
                    const productName = `[${typeName}] ${d.ccp_prod_nm} (${lessonJoinCount}/${d.cc_less_cnt}) ${moment(
                        d.cc_exp_start_dt
                    ).format('YYYY-MM-DD')} ~ ${moment(d.cc_exp_end_dt).format('YYYY-MM-DD')}`;
                    this.editFieldReservCustomer.selectFormCustomerProduct.data.push(productName);
                    this.editFieldReservCustomer.selectFormCustomerProduct.value.push(i);
                }
            } catch (e) {
                console.log(e);
            }
        },

        isDuplicate(id) {
            let answer = false;
            this.editFieldReservCustomer.data.members.forEach((value) => {
                if (!(value.status === '-' && value.reservationStatus === 'RW')) {
                    if (value.centerCustomerId === id) {
                        alert('예약하신 시간에 예약 내역이 있습니다.');
                        answer = true;
                    }
                }
            });
            return answer;
        },
        onSelectSearchCustomerDlg(customer) {
            this.editFieldReservCustomer.selectedCustomer = {
                id: customer.center_cust_id,
                name: customer.namee,
            };
            const isDuplicated = this.isDuplicate(customer.centerCustomerId);
            if (isDuplicated) {
                this.editFieldReservCustomer.selectedCustomer = {};
            } else {
                this.memberPop = false;
                this.isUsedLessonCount = false;
                this.fetchCustomerProductTicket();
            }
        },

        onCancelSearchCustomerDlg() {
            this.memberPop = false;
        },

        onClickBtnOpenSearchCustomer(lessonOffYn) {
            console.log(this.editFieldReservCustomer.data);
            if (!lessonOffYn) {
                this.memberPop = true;
            }
        },

        isEditableMember(member) {
            return member.reservationStatus !== 'RW' && member.status === '-';
        },

        onUpdateSetCustomerProduct(val) {
            const { selectFormCustomerProduct } = this.editFieldReservCustomer;
            selectFormCustomerProduct.selectedValue = val;

            const product = selectFormCustomerProduct.list[val];
            this.editFieldReservCustomer.selectedProduct = product;

            this.checkLessonCountOver(product);
        },

        getReplacedLessonDate(lessonDate) {
            return Utils.isEmpty(lessonDate) ? '' : lessonDate.replace(/-/g, '.');
        },

        nowStatus(member, max) {
            let answer = '';
            let rw = 0;
            let rr = 0;
            if (member === undefined || member === null) {
                return (answer = `${rr}/${max}명`);
            }
            for (let i = 0; i < member.length; i++) {
                if (member[i].reservationStatus === 'RW') {
                    rw++;
                } else {
                    rr++;
                }
            }
            if (rw) {
                answer = `${rr}/${max} 명` + ` (${rw})`;
            } else {
                answer = `${rr}/${max}명`;
            }
            return answer;
        },
        async fetchGroupLessonDetail() {
            try {
                const { centerLessonScheduleId, centerLessonScheduleMasterId } = this.selectedReservation;
                const { data } = await this.getCenterScheduleGroupLessonDetail(
                    centerLessonScheduleId,
                    centerLessonScheduleMasterId
                );

                const { editFieldGroupLesson } = this;
                const { schedulerMaster } = data;

                const startTimes = data.lessonStartTime.split(':');

                editFieldGroupLesson.data = data;
                editFieldGroupLesson.selectedTeacher = data.lessonStaffId;
                editFieldGroupLesson.startHour = startTimes[0];
                editFieldGroupLesson.startMin = startTimes[1];
                editFieldGroupLesson.lessonOffYn = data.lessonOffYn;
                editFieldGroupLesson.lessonName = data.lessonName;
                editFieldGroupLesson.lessonMemberMaxCount = data.lessonMemberMaxCount;
                editFieldGroupLesson.lessonMemberWaitEnableCount = data.lessonMemberWaitEnableCount;
                editFieldGroupLesson.lessonForceOffMemberCount = data.lessonForceOffMemberCount;

                editFieldGroupLesson.selectFormLessonTime.selectedValue = data.lessonTotalTime;

                editFieldGroupLesson.lessonStartDate = schedulerMaster.lessonStartDate;
                editFieldGroupLesson.lessonEndDate = schedulerMaster.lessonEndDate;
                editFieldGroupLesson.scheduleRepeatWeek = schedulerMaster.scheduleRepeatWeek;
                if (editFieldGroupLesson.data.rooms) {
                    this.rooms.selectedValue = editFieldGroupLesson.data.rooms[0].centerRoomId;
                } else {
                    this.rooms.selectedValue = null;
                }

                editFieldGroupLesson.checkedDay = editFieldGroupLesson.scheduleRepeatWeek.split(':');
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        async onClickTabGroupLessonDlgLayer1() {
            this.layerTab = 1;
            await this.fetchGroupLessonReserve();
        },
        async onClickTabGroupLessonDlgLayer2() {
            this.layerTab = 2;
            await this.fetchGroupLessonDetail();
        },

        resetEditFieldReservCustomer() {
            const { editFieldReservCustomer } = this;

            editFieldReservCustomer.data = { members: [] };
            editFieldReservCustomer.selectedCustomer.id = '';
            editFieldReservCustomer.selectedCustomer.name = '';
            editFieldReservCustomer.selectFormCustomerProduct = {
                list: [],
                data: [],
                value: [],
                selectedValue: '',
            };
            editFieldReservCustomer.selectedProduct = null;
            editFieldReservCustomer.customerList = [];
            editFieldReservCustomer.reason = '';
            editFieldReservCustomer.isAttend = true;
            editFieldReservCustomer.checkedNames = [];
        },
        closeGroupReservation() {
            this.reservationPopForGroup = false;
            this.isUsedLessonCount = false;
            this.resetEditFieldReservCustomer();
            this.init();
        },
        onClickBtnCloseGroupReservation() {
            this.closeGroupReservation();
        },
        getCenterScheduleGroupLesson(scheduleId) {
            // 스웨거: 그룹강의 예약내역 조회
            return api.get(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/groupLesson/${scheduleId}`);
        },
        async fetchGroupLessonReserve() {
            try {
                const { data } = await this.getCenterScheduleGroupLesson(
                    this.selectedReservation.centerLessonScheduleId
                );
                this.editFieldReservCustomer.data = data;
            } catch (e) {
                console.log(e);
                Utils.alertResponseErrorMessge(e);
            }
        },

        openReservationDlg(tabNo = 1) {
            this.layerTab = tabNo;
            this.selectedAll = false;
            this.selectedMembers = [];

            this.reservationPopForGroup = true;
        },

        async onClickBtnShowCustomerReservation() {
            this.openReservationDlg(1);
            await this.fetchGroupLessonReserve();
            this.groupInfoPop = false;
        },

        async onClickBtnShowGroupLessonModify() {
            this.openReservationDlg(2);
            await this.fetchGroupLessonDetail();
            this.groupInfoPop = false;
        },

        onClickScheduleItem(item) {
            this.selectedReservation = item;
            this.groupInfoPop = true;
        },

        lessonFirstStudent(lesson) {
            if (Utils.isEmpty(lesson.students) || lesson.students.length === 0) {
                return {
                    lessonJoinCount: 0,
                    lessonCount: 0,
                    name: '',
                };
            }
            return lesson.students[0];
        },
        async init() {
            // 로컬스토리지에 저장한 시간이
            if (this.checkSearchTime()) {
                // 있을경우..
                this.searchTime.startHour = localStorage.getItem('startTime');
                this.searchTime.endHour = localStorage.getItem('endTime');
            }
            this.centerId = parseInt(this.$store.getters['auth/cId']);
            this.staffId = parseInt(this.$store.getters['auth/staffId']);
            await this.fetchCenterRooms();
            this.editFieldGroupLesson.selectFormStartTime.hourList = Utils.getHourList();
            this.editFieldGroupLesson.selectFormStartTime.minList = Utils.getMinsList();

            // 검색 데이터 셋팅
            await this.initSearchField();
            await this.fetchReservationSetting();

            this.isInitFinished = true;
        },
        checkSearchTime() {
            let answer = false;
            try {
                const startTime = localStorage.getItem('startTime');
                const endTime = localStorage.getItem('endTime');
                if (startTime) answer = true;
                if (endTime) answer = true;
            } catch (error) {
                answer = false;
            }
            return answer;
        },
        async initSearchField() {
            await this.fetchCenterChains();
            this.selectedCenterId = this.centerId;
            await this.fetchCenterTeams();
            // 강사 데이터 입력 후 전체 선택
            await this.fetchCenterTearchers();
            // 모든 직원의 스케줄확인 권한 처리
            if (!this.allowedMenuEvent.eventCds.includes('SC_EVENT_006')) {
                this.isCheckAllTeachers = false;
            }
            this.checkAllTeachers(this.isCheckAllTeachers);

            this.redrawScheduleTable();
        },
        async redrawScheduleTable() {
            // 일일스케줄을 가져옴
            this.fetchDailySchedule();
        },
        async fetchDailySchedule() {
            try {
                const { data } = await this.getDailySchedule();
                this.scheduleTable = {};
                let zIndex = 200; // z-index를 5000부터 시작함
                for (const d of data) {
                    const idKey = d.lessonStaffId;
                    let sTimeKey = d.lessonStartTime.split(':')[0];
                    if (Utils.isEmpty(this.scheduleTable[idKey])) {
                        this.scheduleTable[idKey] = {};
                    }
                    if (Utils.isEmpty(this.scheduleTable[idKey][sTimeKey])) {
                        this.scheduleTable[idKey][sTimeKey] = {
                            count: 0,
                            lessonList: [],
                        };
                    }

                    d.titleName = '';
                    d.addedClasses = '';
                    if (d.scheduleType === 'L' && d.lessonsType === 'G') {
                        // 그룹인 경우 강사 이름
                        d.titleName = d.teacher.name;
                    } else if (d.scheduleType === 'M') {
                        // 일정인 경우 일정 이름
                        d.titleName = d.lessonName;
                        d.addedClasses = 'meeting';
                    } else if (!Utils.isEmpty(d.students) && d.students.length > 0) {
                        // 이외에 수강생 이름
                        d.titleName = d.students[0].name;
                    }

                    d.startMin = parseInt(d.lessonStartTime.split(':')[1]);
                    if (d.lessonTotalTime === 0 || Utils.isEmpty(d.lessonTotalTime)) {
                        const lessSt = moment(`${d.lessonDate} ${d.lessonStartTime}`, 'YYYY-MM-DD HH:mm:ss+00');
                        const lessEd = moment(`${d.lessonDate} ${d.lessonEndTime}`, 'YYYY-MM-DD HH:mm:ss+00');
                        const diff = (lessEd.unix() - lessSt.unix()) / 60;
                        d.lessonTotalTime = diff;
                    }
                    if (d.addedClasses === 'meeting') {
                        if (!this.searchTimeHours.includes(sTimeKey)) {
                            console.log('d =>', d);
                            sTimeKey = this.searchTimeHours[0];
                            d.lessonTotalTime = moment(d.lessonDate + ' ' + d.lessonEndTime.substring(0, 5)).diff(
                                moment(d.lessonDate + ' ' + sTimeKey + ':00'),
                                'minutes'
                            );
                            this.scheduleTable[idKey][sTimeKey] = {
                                lessonList: [],
                                count: 0,
                            };
                        }
                    }
                    d.zIndex = zIndex;
                    this.scheduleTable[idKey][sTimeKey].lessonList.push(d);
                    this.scheduleTable[idKey][sTimeKey].count++;

                    // 2021.01.12 notbadlife@evb
                    // vue 인스턴스에서 감지하게 하기 위해 객체 유지.
                    // 해당 부분이 없으면 zIndex 변화를 실시간 적용하지 못한다.
                    // scheduleList는 반드시 인스턴스의 데이터에 선언할 것
                    this.scheduleList.push(d);

                    zIndex++;
                }

                for (const [staffId, hourObject] of Object.entries(this.scheduleTable)) {
                    for (const [hour, schedule] of Object.entries(hourObject)) {
                        schedule.cols = schedule.count > 4 ? 4 : schedule.count;
                        if (schedule.lessonList.length > 1) {
                            for (let i = 1; i < schedule.lessonList.length; i++) {
                                schedule.cols =
                                    schedule.lessonList[i - 1].lessonEndTime === schedule.lessonList[i].lessonStartTime
                                        ? 0
                                        : schedule.count > 4
                                        ? 4
                                        : schedule.count;
                            }
                        }
                    }
                }
            } catch (e) {
                console.error(e);
                Utils.alertResponseErrorMessge(e);
            }
        },
        async fetchCenterChains() {
            try {
                const { data } = await this.getCenterChains();
                const obj = Utils.getSelectFormObjectFromArray('centerName', 'id', data);
                this.selectFormCenter.data = obj.data;
                this.selectFormCenter.value = obj.value;
            } catch (e) {
                console.error(e);
            }
        },
        async fetchCenterTeams() {
            try {
                const { data } = await this.getCenterTeams();
                const obj = Utils.getSelectFormObjectFromArray('name', 'centerTeamId', data, '팀선택', '');
                this.selectFormTeam.data = obj.data;
                this.selectFormTeam.value = obj.value;
            } catch (e) {
                console.error(e);
            }
        },
        async fetchCenterTearchers() {
            this.centerTeachers = [];
            try {
                const { data } = await this.getCenterTearchers();

                this.centerTeachers = data;
                this.centerTeacherMap = {};

                for (const t of this.centerTeachers) {
                    this.centerTeacherMap[t.centerStaffId] = t;
                }

                const obj = Utils.getSelectFormObjectFromArray('name', 'centerStaffId', data, '선택');
                this.selectFormTeacher.data = obj.data;
                this.selectFormTeacher.value = obj.value;
            } catch (e) {
                console.error(e);
            }
        },
        getCenterChains() {
            return api.get(`/admin/api/center/${this.centerId}/chain`);
        },
        getCenterTeams() {
            return api.get(`/admin/api/center/${this.selectedCenterId}/team`);
        },
        getCenterTearchers() {
            // 스웨거 검색: 센터 강사직원 목록조회(리스트)
            return api.get(
                `/admin/api/center/${this.selectedCenterId}/staff/teachers/schedule?date=${this.selectedDate}`
            );
        },
        getDailySchedule() {
            const { startHour, startMin, endHour, endMin } = this.searchTime;
            const staffIdList = this.getCheckedCenterTeacherIds().join(',');
            const searchStartTime = `${startHour}${startMin}00`;
            const searchEndTime = `${endHour}${endMin}59`;
            // const targetDate = this.selectedDate.replace(/-/g, '');
            const targetDate = moment(this.selectedDate).format('YYYYMMDD');
            const lessonType = this.selectedLessonType;

            if (Utils.isEmpty(staffIdList)) {
                alert('선택된 강사가 없습니다.');
                return { data: [] };
            }

            const params = {
                staffIdList,
                searchStartTime,
                searchEndTime,
                targetDate,
                lessonType,
            };

            // 스웨거 검색: 일일스케줄 조회
            return api.get(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/daily/all`, { params });
        },
        getCheckedCenterTeacherIds() {
            console.log(JSON.stringify(this.centerTeachers))

            const ids = [];
            this.centerTeachers.forEach((teacher) => {
                if (teacher.checked) {
                    ids.push(teacher.centerStaffId);
                }
            });
            return ids;
        },
        getCenterCustomer(keyword = '') {
            const params = {
                nameOrPhone: keyword,
                ...this.pagingInfo,
            };

            return api.get(`/admin/api/center/${this.selectedCenterId}/customer`, { params });
        },
        deleteLessonSchedule(params) {
            // scheduleMasterId, scheduleId, customerId, attendanceDevice, scheduleCancelReason
            // /admin/api/center/{centerId}/lesson/schedule/cancelLesson
            // 스웨거 검색: 예약수업 취소처리
            return api.delete(`/admin/api/center/${this.selectedCenterId}/lesson/schedule/cancelLesson`, { params });
        },
        onClickEmptyTimeTable(e, teacher, hour) {
            e.defaultPrevented;
            this.$refs.lessonReservationDlg.resetData();
            this.$refs.lessonReservationDlg.setPresetData({
                selectedTeacher: teacher.centerStaffId,
                lessonDate: this.selectedDate,
                startHour: hour,
                startMin: '00',
            });

            this.$refs.teacherScheduleDlg.setPresetData({
                selectedTeacher: teacher.centerStaffId,
                startDate: this.selectedDate,
                endDate: this.selectedDate,
                startTime: `${hour}:00`,
            });

            if (teacher.centerStaffId !== this.staffId) {
                // 본인 컬럼이 아닌 경우
                if (this.isAllowed('SC', 1)) {
                    // 스케줄과 등록 권한이 있으면
                    this.openLessonReservationDlg();
                } else if (this.isAllowed('SC', 2)) {
                    // 일정 등록 권한이 있으면
                    this.openTeacherScheduleDlg();
                }
                // 두 권한이 없는 경우 아무 창을 띄우지 않는다.
                return;
            }

            this.openLessonReservationDlg();
        },
        async onClickBtnNewReservation() {
            this.$refs.lessonReservationDlg.resetData();
            this.$refs.teacherScheduleDlg.resetData();

            this.$refs.lessonReservationDlg.selectedTeacher = this.staffId;
            this.$refs.teacherScheduleDlg.selectedTeacher = this.staffId;

            await this.$refs.lessonReservationDlg.setPresetData();

            this.openLessonReservationDlg();
        },
        async onClickBtnShowAttendanceAppoval() {
            const { lessonDate, lessonStartTime, students, teacher, centerLessonScheduleId } = this.selectedReservation;
            const { centerCustomerId, lessonJoinCount, lessonCount } = students[0];
            const lessonData = {
                lessonJoinCount,
                lessonCount,
                lessonDate,
                lessonStartTime: this.getHmFromTime(lessonStartTime),
                teacherName: teacher.name,
            };

            await this.$refs.attendanceApprovalDlg.setLessonScheduleData(
                this.selectedCenterId,
                centerCustomerId,
                centerLessonScheduleId,
                lessonData
            );
            this.$refs.attendanceApprovalDlg.show();
            this.closeReservationInfoDlg();
        },
        async onClickBtnShowMeeting(item) {
            this.layerTab = 2;

            this.selectedReservation = { ...item };

            const presetData = this.getTeacherScheduleDataWithSelectedReservation();
            this.$refs.teacherScheduleDlg.setPresetData(presetData);

            this.reservationDlg.isModifyTeacherSchedule = true;

            this.openTeacherScheduleDlg();
        },
        async onClickBtnShowReservation() {
            this.layerTab = 1;
            const presetData = this.getLessonReservationDataWithSelectedReservation();
            this.$refs.lessonReservationDlg.setPresetData(presetData);
            this.reservationDlg.isModifyLessonReservation = true;
            this.closeReservationInfoDlg();
            this.openLessonReservationDlg();
        },
        checkCancelReservation(date, time = '') {
            // 기본값 셋팅
            const now = moment();
            let dFormat = 'YYYY-MM-DD';
            let reservDate = date;

            if (!Utils.isEmpty(time)) {
                reservDate = `${date} ${time}:00`;
                dFormat = `${dFormat} HH:mm:ss`;
            }

            // 취소 가능 설정
            const { lessonsType } = this.selectedReservation;

            let dtStr = '';
            switch (lessonsType) {
                case 'P':
                case 'O':
                    dtStr = this.reservationSetting.teacherReservationOt;
                    break;
                case 'D':
                    dtStr = this.reservationSetting.teacherReservationDu;
                    break;
                case 'G':
                    dtStr = this.reservationSetting.teacherReservationGr;
                    break;
                default:
                    return true;
            }

            // 날짜 체크. 이전 날짜이면 예약 불가
            // 에약 가능한 최대 날짜 산출
            const [day, hour, min] = dtStr.split('-');

            // 0일 0시 0분으로 세팅되어 있으면 그냥 통과 시킨다.
            if (day === 0 && hour === 0 && min === 0) {
                return true;
            }

            const limitDate = moment().subtract(parseInt(day), 'days');
            if (!Utils.isEmpty(time)) {
                limitDate.subtract(parseInt(hour), 'hours').subtract(parseInt(min), 'minutes');
            }

            // 예약 가능일 이후 부터 현재까지의 범위 안에 예약일시가 있어야 취소 가능
            return moment(reservDate).isAfter(limitDate);
        },
        async onClickBtnCancelSelectedReservation() {
            const { lessonDate, lessonStartTime } = this.selectedReservation;

            const lessonTime = lessonStartTime.substr(0, 5);
            const limitResult = this.checkCancelReservation(lessonDate, lessonTime);
            if (!this.isAllowed('SC', 1) && !limitResult) {
                alert('취소 가능한 시간이 지났습니다. 센터관리자에게 문의하세요.');
                return false;
            }

            if (confirm('예약을 취소하시겠습니까?')) {
                try {
                    const { centerLessonScheduleMasterId, centerLessonScheduleId, students } = this.selectedReservation;
                    const params = {
                        scheduleMasterId: centerLessonScheduleMasterId,
                        scheduleId: centerLessonScheduleId,
                        customerId: students[0].centerCustomerId,
                        attendanceDevice: 'AW',
                        scheduleCancelReason: '',
                    };

                    await this.deleteLessonSchedule(params);

                    this.closeReservationInfoDlg();
                    this.closeReservationDlg();

                    this.redrawScheduleTable();
                } catch (e) {
                    console.error(e);
                    Utils.alertResponseErrorMessge(e);
                }
            }
        },
        onClickBtnShowReservationCustomerInfo() {
            const { students } = this.selectedReservation;
            const customer = students[0];

            this.$router.push({
                path: `/madmin/member/info/${this.selectedReservation.centerId}`,
                query: { customerId: customer.centerCustomerId },
            });
        },
        onClickGroupLessonItem(item) {
            this.selectedReservation = { ...item };
        },
        onClickDailyScheduleItem(item) {
            // 수정시 영향을 받지 않도록 Deep-Copy
            this.selectedReservation = { ...item };
            this.openReservationInfoDlg();
        },
        onCancelScheduleTimeSetterDlg() {
            this.timePop = false;
        },
        onConfirmScheduleTimeSetterDlg(times) {
            const { startHour, endHour } = times;

            this.searchTime.startHour = startHour;
            this.searchTime.endHour = endHour;
            // 시간 값을 저장..
            localStorage.setItem('startTime', startHour);
            localStorage.setItem('endTime', endHour);

            this.timePop = false;

            this.redrawScheduleTable();
        },
        onClickBtnOpenScheduleTimeSetter() {
            this.timePop = true;
        },
        onClickBtnModifyReservation() {},
        onClickBtnCancelReservation() {
            this.closeReservationDlg();
        },
        onChangeCheckTeacher(event) {
            if (this.isCheckAllTeachers && !event.target.checked) this.isCheckAllTeachers = false;

            this.refreshCheckedTeachers();
            this.fetchDailySchedule();
        },
        onClickBtnLessonType(type) {
            this.selectedLessonType = type;
            this.fetchDailySchedule();
        },
        onClickBtnCloseReservationInfoDlg() {
            this.closeReservationInfoDlg();
            this.selectedReservation = null;
        },
        onChangeCheckAllTeachers() {
            this.checkAllTeachers(this.isCheckAllTeachers);
            this.fetchDailySchedule();
        },
        onMouseoverSchedule(item) {
            if (item.zIndex !== this.topZIndex) {
                item._zIndex = item.zIndex;
                item.zIndex = this.topZIndex;
            }
        },
        onMouseleaveSchedule(item) {
            if (!Utils.isEmpty(item._zIndex)) {
                item.zIndex = item._zIndex;
                item._zIndex = '';
            }
        },
        scheduleClass(item) {
            // 스케줄표의 종료시간에 따라 크기 변경
            const searchEndHour = moment(parseInt(this.searchTime.endHour) + 1, 'HH');
            const lessonEndHour = moment(item.lessonEndTime, 'HH:mm:ss');

            let lessonTotalTime = item.lessonTotalTime;
            if (searchEndHour.isBefore(lessonEndHour)) {
                const lessonStartTime = moment(item.lessonStartTime, 'HH:mm:ss');
                lessonTotalTime = searchEndHour.diff(lessonStartTime, 'minutes');
            }

            return [`m${item.startMin}`, `h${lessonTotalTime}`];
        },
        scheduleStyle(item) {
            // :style="`border-color:${d.teacher.color}; z-index: ${d.zIndex}`"
            return {
                borderColor: item.teacher.color,
                zIndex: item.zIndex,
            };
        },
        meetingStyle(item) {
            return {
                zIndex: item.zIndex,
            };
        },
        checkAllTeachers(checked) {
            console.log('checkAllTeachers', checked)
            for (const t of this.centerTeachers) {
                // 모든 직원의 스케줄확인 권한 처리
                if (!this.allowedMenuEvent.eventCds.includes('SC_EVENT_006')) {
                    if (t.centerStaffId === this.staffId) {
                        t.checked = true;
                    }
                } else {
                    t.checked = checked;
                }
            }

            this.refreshCheckedTeachers();
        },
        outsideClick() {
            this.selectOpen = false;
        },
        onCancelTeacherScheduleDlg() {
            this.closeReservationDlg();
        },
        onSuccessTeacherScheduleDlg() {
            this.redrawScheduleTable();
            this.closeReservationDlg();
        },
        onCancelLessonReservationDlg() {
            this.closeReservationDlg();
        },
        onSuccessLessonReservationDlg() {
            this.redrawScheduleTable();

            this.closeReservationDlg();
        },
        onSuccessAttendApproval() {
            this.redrawScheduleTable();
        },
        async onUpdateSelectedCenter(v) {
            this.selectedCenterId = v;

            await this.fetchCenterTeams();

            await this.fetchCenterTearchers();
            this.isCheckAllTeachers = true;
            this.checkAllTeachers(this.isCheckAllTeachers);

            await this.redrawScheduleTable();
        },
        onUpdateSelectedTeam(v) {
            this.selectFormTeam.selectedValue = v;
            this.fetchCenterTearchersByTeam();
            // this.fetchCenterTearchers();
        },
        closeReservationDlg() {
            this.reservationPop = false;
            this.layerTab = 1;

            this.$refs.lessonReservationDlg.resetData();
            this.$refs.teacherScheduleDlg.resetData();
            this.reservationDlg.isModifyLessonReservation = false;
            this.reservationDlg.isModifyTeacherSchedule = false;
        },
        openLessonReservationDlg() {
            this.layerTab = 1;
            // this.$refs.lessonReservationDlg.selectedTeacher = this.staffId;
            this.$refs.lessonReservationDlg.show();
            this.$refs.teacherScheduleDlg.hide();
            this.reservationPop = true;
        },
        openTeacherScheduleDlg() {
            this.layerTab = 2;
            // this.$refs.teacherScheduleDlg.selectedTeacher = this.staffId;
            this.$refs.lessonReservationDlg.hide();
            this.$refs.teacherScheduleDlg.show();
            this.reservationPop = true;
        },
        closeReservationInfoDlg() {
            this.infoPop = false;
        },
        openReservationInfoDlg() {
            this.infoPop = true;
        },
        refreshCheckedTeachers() {
            this.checkedTeachers = [];
            for (const t of Utils.getSort(this.centerTeachers, 'name')) {
                if (t.checked) {
                    this.checkedTeachers.push(t);
                }
            }
        },
        getTeacherScheduleDataWithSelectedReservation() {
            const { selectedReservation } = this;
            const preset = {};

            preset.isModify = true;
            // 선택정보에서 셋팅할 값
            preset.centerLessonScheduleId = selectedReservation.centerLessonScheduleId;
            preset.centerLessonScheduleMasterId = selectedReservation.centerLessonScheduleMasterId;
            preset.selectedTeacher = selectedReservation.teacher.centerStaffId;
            preset.lessonDate = selectedReservation.lessonDate;
            preset.startTime = this.getHmFromTime(selectedReservation.lessonStartTime);
            preset.endTime = this.getHmFromTime(selectedReservation.lessonEndTime);
            preset.lessonName = selectedReservation.lessonName;
            preset.meetingType = selectedReservation.centerScheduleType;
            preset.memo = selectedReservation.lessonMemo;

            return preset;
        },
        getLessonReservationDataWithSelectedReservation() {
            const { selectedReservation } = this;
            const preset = {};

            // 회원 정보
            const customer = selectedReservation.students[0];

            // 수정 기본 정보
            preset.isModify = true;
            preset.centerLessonScheduleId = selectedReservation.centerLessonScheduleId;
            preset.centerLessonScheduleMasterId = selectedReservation.centerLessonScheduleMasterId;

            preset.selectedTeacher = selectedReservation.teacher.centerStaffId;
            preset.selectedCustomer = {
                name: customer.centerCustomerName,
                id: customer.centerCustomerId,
            };

            preset.lessonDate = selectedReservation.lessonDate;
            const lessonTimeArr = selectedReservation.lessonStartTime.split(':');
            preset.startHour = lessonTimeArr[0];
            preset.startMin = lessonTimeArr[1];
            preset.lessonTime = selectedReservation.lessonTotalTime === 0 ? 60 : selectedReservation.lessonTotalTime;
            preset.memo = selectedReservation.lessonMemo;
            preset.isUnableCancel = this.isSelectedReservationUnableCancel;
            preset.billStatus = selectedReservation.students[0].billStatus;
            preset.lessonType = selectedReservation.lessonsType;

            // 방정보 셋팅
            preset.rooms = [];
            if (!Utils.isEmpty(selectedReservation.rooms)) {
                for (const room of selectedReservation.rooms) {
                    const useStartTime = room.useStartTime.split('+')[0].substring(0, 5);
                    const useEndTime = room.useEndTime.split('+')[0].substring(0, 5);
                    preset.rooms.push({
                        centerRoomId: room.centerRoomId,
                        useStartTime,
                        useEndTime,
                    });
                }
            }

            return preset;
        },
        checkAllowedClickEditAction(successCallback, item, index) {
            // 스케줄 관리 권한
            if (this.isAllowed('SC', 1) || this.selectedReservation.lessonStaffId === this.staffId) {
                successCallback(item, index);
            } else {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }
        },
        checkAllowedClickAttendAction(successCallback) {
            // 출결 승인 관리 권한
            if (
                this.isAllowed('SC', 4) ||
                (this.isAllowed('SC', 3) && this.selectedReservation.lessonStaffId === this.staffId)
            ) {
                // 전체 권한이 있거나, 본인만 권한이 있는 경우
                successCallback();
            } else {
                alert('사용권한이 없습니다. 대표관리자에게 권한을 요청하세요.');
                return false;
            }
        },
        isNumber(evt) {
            return Utils.isNumber(evt);
        },
        isEmpty(v) {
            return Utils.isEmpty(v);
        },
        getHmFromTime(time) {
            try {
                return time.split(':').splice(0, 2).join(':');
            } catch {}
        },

        async checkLessonCountOver(product) {
            const { cc_center_id, cc_center_cust_id, cc_center_contract_id, cp_center_prod_id } = product;

            const { data } = await this.getCheckLessonCount(
                cc_center_id,
                cc_center_cust_id,
                cc_center_contract_id,
                cp_center_prod_id
            );

            this.isUsedLessonCount = data.result;
        },
        async fetchCenterTearchersByTeam() {
            const { data } = await this.getCenterTearchersByTeam();
            this.centerTeachers.forEach((teacher) => {
                teacher.checked = false;
                data.forEach((staff) => {
                    if (teacher.centerStaffId === staff.centerStaffId) {
                        teacher.checked = true;
                    }
                });
            });
            this.refreshCheckedTeachers();
        },
        getCenterTearchersByTeam() {
            // 스웨거 검색: 센터 강사직원 목록조회(팀 기준)
            return api.get(`/admin/api/center/${this.selectedCenterId}/staff/teachers/list/centerTeam`, {
                params: {
                    centerTeamId: this.selectFormTeam.selectedValue,
                },
            });
        },
        async fetchReservationSetting() {
            const { data } = await this.getCenterReservSetting();

            this.reservationSetting = data;
        },
        getCenterReservSetting() {
            // 스웨거 검색: 센터예약시간설정 조회
            return api.get(`/admin/api/center/${this.centerId}/reservation-setting`);
        },
        test(params) {
            let test = '';
            if (params[0] === 'm30' && params[1] === 'h30') {
                test = 'float:right; display:flex;';
            } else if (params[0] === 'm0' && params[1] === 'h30') {
                test = 'float:right; display:flex;';
            } else {
                test = '';
            }
            return test;
        },
    },
};
</script>

<style lang="scss">
.com-tab {
    margin-top: 24px;
}

.top-group-info {
    color: #535353 !important;
}

.check-link .link {
    text-decoration: underline;
}

.com-btn.outline {
    border: 1px solid #ced4da;
    background: #fff;
    color: #707070;
}
</style>
